import { setLoading, setGlobalMessage } from '../../../app';
import { ALERT_SEVERITY, ERROR_MESSAGES, GLOBAL_VALUES } from 'eebac/constants';
import { Catch } from '../../../api_exception';

import RFQ_FIELDS_PART_1 from 'eebac/constants/fields/compnay/rfq/rfq_part_1';
import RFQ_FIELDS_PART_2 from 'eebac/constants/fields/compnay/rfq/rfq_part_2';
import RFQ_FIELDS_PART_3 from 'eebac/constants/fields/compnay/rfq/rfq_part_3';
import RFQ_FIELDS_PART_4 from 'eebac/constants/fields/compnay/rfq/rfq_part_4';
import RFQ_FIELDS_PART_5 from 'eebac/constants/fields/compnay/rfq/rfq_part_5';
import RFQ_FIELDS_PART_6 from 'eebac/constants/fields/compnay/rfq/rfq_part_6';
import RFQ_FIELDS_PART_7 from 'eebac/constants/fields/compnay/rfq/rfq_part_7';
import { setRfqInfoData } from '../../rfq_info';
import ApiDataHelper from 'eebac/utils/apiDataHelper';
import fileDownload from 'js-file-download';

const BASE_PATH = "COMPANY_WORK_RFQ";

export const loadRfqs = (rowsPerPage = null, page = null, clearExisting = true, resetFilters = false) =>
    (dispatch, getState, client) => {
        let state = getState().COMPANY_WORK_RFQS;
        let filters = [];

        if (!resetFilters) {
            if (state.state) {
                filters.push({ name: "state", values: [state.state] });
            }

            if (state.city && Array.isArray(state.city) && state.city.length > 0) {
                filters.push({ name: "city", values: state.city });
            }

            if (state.firmType && Array.isArray(state.firmType) && state.firmType.length > 0) {
                filters.push({ name: "firmType", values: state.firmType });
            }

            if (state.workType && Array.isArray(state.workType) && state.workType.length > 0) {
                filters.push({ name: "workType", values: state.workType });
            }
        }

        let apiData = {
            itemsCount: state.rowsPerPage,
            currentPage: state.page + 1,
        }

        if (filters.length > 0) {
            apiData.filters = filters;
        }

        if (rowsPerPage) {
            apiData.itemsCount = rowsPerPage;
        }

        if (page !== null) {
            apiData.currentPage = page + 1;
        }

        if (clearExisting) {
            dispatch(setRfqsData([], 0, apiData.itemsCount, 0));
        }

        dispatch(setLoading(true));
        dispatch(isLoadingRecords(true));

        client.post('/company/rfqs', apiData).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.rfqs) {
                    dispatch(setRfqsData(result.data.rfqs,
                        (result.currentPage - 1), result.itemsCount, result.totalCount));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
                dispatch(isLoadingRecords(false));
            }).catch(error => {
                dispatch(isLoadingRecords(false));
                Catch(error, dispatch);
            });
    }

export const loadRfq = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/company/rfq/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.rfq) {
                    dispatch(setRfqData(result.data.rfq));
                    dispatch(viewRfq(true));
                } else {
                    dispatch(setRfqData(null));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(viewRfq(false));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setRfqData(null));
                dispatch(viewRfq(false));
            });
    }

export const downloadRfqBoq = (id, fileName = "boq") =>
    (dispatch, getState, client) => {
        client.get(`/company/rfq/boq/${id}`, { responseType: 'blob' })
            .then(result => {
                fileDownload(result.data, fileName);
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const downloadRfqQuotation = (id, fileName = "quotation") =>
    (dispatch, getState, client) => {
        client.get(`/company/rfq/quotation/${id}`, { responseType: 'blob' })
            .then(result => {
                fileDownload(result.data, fileName);
            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const deleteRfq = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.delete(`/company/rfq/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess) {
                    dispatch(setGlobalMessage(result.successMessage,
                        ALERT_SEVERITY.SUCCESS));
                    dispatch(loadRfqs(null, null, false));
                } else {
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                    dispatch(setLoading(false));
                }

            }).catch(error => {
                Catch(error, dispatch);
            });
    }

export const editRfq = (id) =>
    (dispatch, getState, client) => {
        dispatch(setLoading(true));

        client.get(`/company/work_rfq_edit/${id}`).
            then(res => res.data).then(result => {
                if (result.isSuccess &&
                    result.data.rfq) {
                    let FIELDS = {
                        ...RFQ_FIELDS_PART_1,
                        ...RFQ_FIELDS_PART_2,
                        ...RFQ_FIELDS_PART_3,
                        ...RFQ_FIELDS_PART_4,
                        ...RFQ_FIELDS_PART_5,
                        ...RFQ_FIELDS_PART_6,
                        ...RFQ_FIELDS_PART_7
                    };

                    FIELDS.id = id;
                    FIELDS.firmName = '';

                    let rfqData = result.data.rfq;
                    rfqData.id = id;

                    ApiDataHelper.set(
                        (data) => dispatch(setRfqInfoData(data)), rfqData, FIELDS);

                    dispatch(setEditRfq(true));

                } else {
                    dispatch(setEditRfq(false));
                    dispatch(setGlobalMessage(result.errorMessage ?
                        result.errorMessage :
                        ERROR_MESSAGES.SERVER_FAULT, ALERT_SEVERITY.ERROR));
                }
                dispatch(setLoading(false));
            }).catch(error => {
                Catch(error, dispatch);
                dispatch(setEditRfq(false));
            });
    }

export const SET_RFQS_DATA = `${BASE_PATH}/SET_RFQS_DATA`;
export const SET_FILTERS_DATA = `${BASE_PATH}/SET_FILTERS_DATA`;
export const SET_RFQ = `${BASE_PATH}/SET_RFQ`;
export const VIEW_RFQ = `${BASE_PATH}/VIEW_RFQ`;
export const OPEN_CONFIRM_DIALOG = `${BASE_PATH}/OPEN_CONFIRM_DIALOG`;
export const EDIT_RFQ = `${BASE_PATH}/EDIT_RFQ`;
export const OPEN_SCHEDULE = `${BASE_PATH}/OPEN_SCHEDULE`;
export const SET_LOADING_RECORDS = `${BASE_PATH}/SET_LOADING_RECORDS`;

export const setRfqsData = (rfqs, page, rowsPerPage, totalRows) => ({
    type: SET_RFQS_DATA,
    rfqs,
    page,
    rowsPerPage,
    totalRows
});

export const setEditRfq = (edit) => ({
    type: EDIT_RFQ,
    edit
});

export const viewRfq = (open) => ({
    type: VIEW_RFQ,
    open
});

export const setFiltersData = (data) => ({
    type: SET_FILTERS_DATA,
    data
});

export const setRfqData = (data) => ({
    type: SET_RFQ,
    data
});

export const openConfirmDialog = (open, selectedRfqId) => ({
    type: OPEN_CONFIRM_DIALOG,
    open,
    selectedRfqId
});

export const openSchedule = (open, selectedSchedulePostId) => ({
    type: OPEN_SCHEDULE,
    open,
    selectedSchedulePostId
});

export const isLoadingRecords = (isLoadingRecords) => ({
    type: SET_LOADING_RECORDS,
    isLoadingRecords
});

const initialState = {
    rfqs: [],
    page: 0,
    rowsPerPage: GLOBAL_VALUES.DEFAULT_ROWS_PER_PAGE,
    totalRows: 0,

    state: '',
    city: [],
    firmType: [],
    workType: [],

    stateError: '',
    cityError: '',
    firmTypeError: '',
    workTypeError: '',

    viewRfq: false,
    rfqData: null,
    openConfirmDialog: false,
    selectedRfqId: null,
    editRfq: false,
    openSchedule: false,
    selectedSchedulePostId: null,
    isLoadingRecords: false
}

export default function reducer(state = { ...initialState }, action) {
    let newState = null;
    switch (action.type) {
        case SET_RFQS_DATA:
            newState = {
                ...state,
                rfqs: [...action.rfqs],
                page: action.page,
                rowsPerPage: action.rowsPerPage,
                totalRows: action.totalRows
            };
            return newState;
        case SET_FILTERS_DATA:
            newState = { ...state };
            action.data.forEach(data => {
                newState[data.key] = data.value;
            });
            return newState;
        case VIEW_RFQ:
            return { ...state, viewRfq: action.open };
        case SET_RFQ:
            return {
                ...state,
                rfqData: action.data
            }
        case OPEN_CONFIRM_DIALOG:
            return {
                ...state,
                openConfirmDialog: action.open,
                selectedRfqId: action.selectedRfqId
            }
        case EDIT_RFQ:
            return { ...state, editRfq: action.edit };
        case OPEN_SCHEDULE:
            return {
                ...state,
                openSchedule: action.open,
                selectedSchedulePostId: action.selectedSchedulePostId
            }
        case SET_LOADING_RECORDS:
            return {
                ...state,
                isLoadingRecords: action.isLoadingRecords
            }
    }

    return state;
}